<div class="credit-card" [class]="statusClass">
  <div class="card-header">
    <div class="header-info">
      <i class="pi pi-users"></i>
      <h3>Información del Accionista</h3>
    </div>
    <div class="completion-indicator">
      <span class="percentage">{{ completionPercentage }}%</span>
      <div class="progress-bar">
        <div class="progress-fill" [style.width.%]="completionPercentage"></div>
      </div>
    </div>
  </div>

  <div class="card-content">
    <div *ngIf="!hasData" class="no-data">
      <i class="pi pi-users"></i>
      <p>No hay información de accionistas disponible</p>
    </div>

    <div *ngIf="hasData" class="data-sections">
      <!-- Información Principal -->
      <div class="section">
        <h4 class="section-title">Información Principal</h4>
        <div class="data-grid">
          <div class="data-item featured" *ngIf="shareholderName !== 'No especificado'">
            <label>{{ shareholderType === 'company' ? 'Razón Social' : 'Nombre Completo' }}:</label>
            <span class="value shareholder-name" [class]="'type-' + shareholderType">
              {{ shareholderName }}
            </span>
          </div>

          <div class="data-item percentage-item" [class.empty]="!data?.percentage">
            <label>Porcentaje de Participación:</label>
            <span [class]="data?.percentage ? 'value percentage-badge' : 'placeholder'" 
                  [attr.data-status]="percentageStatus">
              {{ percentageDisplay }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.rfc">
            <label>RFC:</label>
            <span [class]="data?.rfc ? 'value' : 'placeholder'">
              {{ data?.rfc || 'No especificado' }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.curp" *ngIf="shareholderType === 'individual'">
            <label>CURP:</label>
            <span [class]="data?.curp ? 'value' : 'placeholder'">
              {{ data?.curp || 'No especificado' }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.clientType">
            <label>Tipo de Cliente:</label>
            <span [class]="data?.clientType ? 'value' : 'placeholder'">
              {{ data?.clientType || 'No especificado' }}
            </span>
          </div>
        </div>
      </div>

      <!-- Información de Contacto -->
      <div class="section">
        <h4 class="section-title">Información de Contacto</h4>
        <div class="data-grid">
          <div class="data-item featured" 
               *ngIf="fullAddress !== 'No especificado'"
               [class.empty]="fullAddress === 'No especificado'">
            <label>Dirección Completa:</label>
            <span class="value address-full">{{ fullAddress }}</span>
          </div>

          <div class="data-item" [class.empty]="!data?.phone">
            <label>Teléfono:</label>
            <span [class]="data?.phone ? 'value' : 'placeholder'">
              {{ formatPhone(data?.phone) }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.extension" *ngIf="data?.extension">
            <label>Extensión:</label>
            <span class="value">{{ data?.extension }}</span>
          </div>

          <div class="data-item" [class.empty]="!data?.fax" *ngIf="data?.fax">
            <label>Fax:</label>
            <span class="value">{{ data?.fax }}</span>
          </div>
        </div>
      </div>

      <!-- Información Adicional -->
      <div class="section" *ngIf="data?.foreignState || data?.country">
        <h4 class="section-title">Información Adicional</h4>
        <div class="data-grid">
          <div class="data-item" [class.empty]="!data?.foreignState" *ngIf="data?.foreignState">
            <label>Estado Extranjero:</label>
            <span class="value">{{ data?.foreignState }}</span>
          </div>

          <div class="data-item" [class.empty]="!data?.country" *ngIf="data?.country">
            <label>País:</label>
            <span class="value">{{ data?.country }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
